import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import BorderTax from "./pages/BorderTax";
import CreateOrEditBorderTax from "./pages/CreateOrEditBorderTax";
import AllBorderTax from "./pages/AllBorderTax";
import ProviderManagement from "./pages/ProviderManagement";
import ProviderTaxRequests from "./pages/ProviderTaxRequests";
import TransferedTaxesThree from "./pages/TransferedTaxesThree";
import RoadTaxTransferByMe from "./pages/RoadTaxTransferByMe";
import TransferedAipt from "./pages/TransferedAipt";
import ProviderThreeMonth from "./pages/ThreeMonthWalaProvider";
import ProviderTaxStats from "./pages/ProviderTaxStats";
import BorderTaxUi from "./pages/BorderTaxUi";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route
              path="/"
              element={<Navigate to="/border-tax" replace />}
            />

            <Route path="/border-tax" element={<BorderTax />} />

            <Route
              path="/border-tax/create"
              element={<CreateOrEditBorderTax />}
            />

            <Route
              path="/border-tax/ui"
              element={<BorderTaxUi />}
            />
            <Route
              path="/border-tax/edit/:id"
              element={<CreateOrEditBorderTax />}
            />

            <Route
              path="/border-tax-orders"
              element={<AllBorderTax />}
            />

            <Route
              path="/border-tax-new"
              element={<ProviderTaxRequests />}
            />

            <Route
              path="/transferd-tax-new"
              element={<TransferedTaxesThree />}
            />

            <Route
              path="/road-transferd-tax-new"
              element={<RoadTaxTransferByMe />}
            />

            <Route
              path="/aipt-transferd-tax-new"
              element={<TransferedAipt />}
            />

            <Route
              path="/provider/tax-stats"
              element={<ProviderTaxStats />}
            />

            <Route
              path="/assign-border-all-new-tax"
              element={<ProviderThreeMonth />}
            />

            <Route
              path="/providers"
              element={<ProviderManagement />}
            />
          </Route>

          <Route
            path="*"
            element={<Navigate to="/border-tax" replace />}
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;